
import { Component, Vue, Prop } from "vue-property-decorator";
import { accountApi } from "../services/api/account/account";
import { UpdateEmailVerifiedCommand } from "../services/api/models/UpdateEmailVerifiedCommand.model";
import TransitionMessage from "./TransitionMessage.vue";

@Component({ components: { TransitionMessage } })
export default class EmailVerified extends Vue {
  @Prop() readonly profile: any;

  private errorMessageShow = false;
  private errorMessage = "";
  private isEmailVerifiedEditing = true;
  private isSavingEmailVerified = false;
  private emailVerified = "";
  private emailVerifiedValid = "";
  $t: any;

  async mounted() {
    await this.load();
  }

  async load() {
    let profile = this.profile;
    this.emailVerified = profile.emailVerified ?? "";
    this.emailVerifiedValid = profile.emailVerifiedValid;
    this.isEmailVerifiedEditing = this.emailVerified === "";
  }

  async saveEmailVerified() {
    this.isSavingEmailVerified = true;
    this.errorMessageShow = false;
    this.errorMessage = "";

    if (this.emailVerified === "" || this.emailVerified === null) {
      this.isSavingEmailVerified = false;
      this.errorMessageShow = true;
      this.errorMessage = "Ingrese un <strong>correo electrónico</strong>.";
      return;
    }

    try {
      const data = new UpdateEmailVerifiedCommand(this.emailVerified);
      await accountApi.updateEmailVerified(data);
      this.isEmailVerifiedEditing = false;
      this.emailVerifiedValid = "0";
    } catch (error) {
      if (error?.response?.data) {
        this.errorMessageShow = true;
        this.errorMessage = this.$t(`errors.${error.response.data}`);
      } else if (error) {
        this.errorMessageShow = true;
        this.errorMessage = error;
      }
    } finally {
      this.isSavingEmailVerified = false;
    }
  }
}
